export function checkValue(value) {
  return value ? value : "-";
}

export function checkNotNull(value) {
  return value === null || value === undefined ? "-" : value;
}
